import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@ngneat/transloco';
import { BusinessReviewSite } from '../../core/models/business-review-site.model';
import { AuditService } from '../../core/services/audit.service';
import { ConfigService } from '../../core/services/config.service';
import { InitParamsService } from '../../core/services/init-params.service';
import { ModalName, ModalService } from '../../core/services/modal.service';
import { StoreIdService } from '../../core/services/store-id.service';
import { IconNameType } from '../../shared/icons/icon-name-type.enum';
import { RoundIconComponent } from '../../shared/round-icon/round-icon.component';
import { TextButtonComponent } from '../../shared/text-button/text-button.component';

@Component({
  selector: 'cwo-completed-survey-modal',
  standalone: true,
  imports: [RoundIconComponent, TranslocoPipe, TextButtonComponent],
  templateUrl: './completed-survey-modal.component.html',
  styleUrl: './completed-survey-modal.component.scss',
})
export class CompletedSurveyModalComponent {
  private configService = inject(ConfigService);
  private router = inject(Router);
  private storeId = inject(StoreIdService).storeId;
  private initParamsService = inject(InitParamsService);
  private auditService = inject(AuditService);

  modalService = inject(ModalService);
  iconNameType = IconNameType;
  businessReviewSites: BusinessReviewSite[] = this.configService.configState().store?.businessReviewSites || [];

  iconMap: Record<string, IconNameType> = {
    Google: this.iconNameType.googleLogo,
    Facebook: this.iconNameType.facebookLogo,
    Yelp: this.iconNameType.yelpLogo,
  };

  get siteEntries() {
    if (this.businessReviewSites?.length) {
      return this.businessReviewSites.map(s => ({
        ...s,
        icon: this.iconMap[s.name],
      }));
    }
    return []
  }

  getSafeUrl(siteUrl: string): string {
    if (siteUrl.startsWith('http://') || siteUrl.startsWith('https://')) {
      return siteUrl;
    }
    return 'https://' + siteUrl;
  }

  closeSurveyModal() {
    this.modalService.closeModal(ModalName.SurveySubmittedLinks);
  }

  backToMenu() {
    this.modalService.closeModal(ModalName.SurveySubmittedLinks);
    this.initParamsService.clearParam('ref');
    this.initParamsService.clearParam('refCode');
    this.router.navigate(['/', this.storeId, 'menu'], { replaceUrl: true });
    this.auditService.createAudit(
      () => 'Go back to main page button clicked on Survey-Review Links modal'
    );
  }

}
